export default "__VITE_ASSET__421bed82__"